import * as React from 'react';
import { jsx, css, keyframes } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { UserMessagePropsType } from '../..';

const { tablet, mobile } = mediaQueries();

type UserChatBubblePropsType = Merge<UserMessagePropsType & {
  isLoading: boolean;
}>;

export const UserChatBubble = ({
  messageElement,
  isLoading,
}: UserChatBubblePropsType) => {
  return (
    <div
      css={css`
        font-size: 20px;
        width: fit-content;
        min-height: calc(1lh + 18px);
        padding: 9px 12px;
        background-color: #ffec87;
        border-radius: 22px;
        position: relative;

        ${mobile(({ clamp }) => css`
          font-size: ${clamp('13px', '16px')};
        `)}

        ${isLoading && css`
          display: flex;
          align-items: center;
        `}

        &::before {
          content: "";
          width: 15px;
          height: 14px;
          background-color: #ffec87;
          clip-path: polygon(100% 0, 0 50%, 100% 100%);
          position: absolute;
          transform: rotate(145deg);
          bottom: calc(100% - 12px);
          left: calc(100% - 8px);

          ${isLoading && css`
            display: none;
          `}
        }
      `}
    >
      {isLoading && (
        <div
          css={css`
            width: 90px;
          `}
        >
          <div
            css={css`
              padding-top: 1em;
              font-size: 10px;
              text-align: center;
              display: flex;
              justify-content: center;
              gap: 0 6px;

              & > div {
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 50%;
                animation: ${keyframes`
                  0% {
                    transform: translateY(0) ;
                    opacity: 0.2;
                  }
                  50% {
                    transform: translateY(-10px) ;
                    opacity: 0.6;
                  }
                  100% {
                    transform: translateY(0) ;
                    opacity: 0.2;
                  }
                `} 0.8s infinite linear;
              }

              & > div:nth-of-type(2) {
                animation-delay: -0.6s;
              }

              & > div:nth-of-type(3) {
                animation-delay: -0.4s;
              }
            `}
          >
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      {!isLoading && (
        <p
          css={css`
            color: #333;
          `}
        >
          {messageElement}
        </p>
      )}
    </div>
  );
};
